export const parseAddress = (address: string | null, city: string | null): string => {
  if (!address && !city) return ''
  if (address && !city) return address
  if (!address && city) return city
  return `${address}, ${city}`
}
